var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.input,
          expression: "input"
        }
      ],
      staticClass: "input-tags",
      attrs: {
        id: _vm.id,
        placeholder: _vm.placeholder,
        disabled: _vm.disabled,
        type: "text"
      },
      domProps: { value: _vm.input },
      on: {
        value: _vm.tags,
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.input = $event.target.value
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2409e956", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2409e956","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/InputTags.vue
// module id = null
// module chunks = 